<template>
  <v-flex xs4 sm2 md2 class='grid-cards'>

    <v-card
      color='elevation-0'
      :to="{ name: 'Edicao', params: { issueId: this.$props.id }}"
      :class='this.$props.className'
    >

      <div class='card-img'>

        <v-img
          :src='this.$props.img' v-if='this.$props.img' :class="{
                blocked: this.$props.issue.isFree === false && activeSubscription() === false,
                motion: this.$props.issue.type === 'video'
          }"
        ></v-img>
      </div>

      <v-card-title class='px-0'>
        <div class='subheading pb-2'>{{ this.$props.title }}</div>
        <span>{{ this.$props.subtitle }}</span>
      </v-card-title>

    </v-card>

  </v-flex>
</template>

<script>
export default {
  name: 'cardIssue',
  props: {
    issue: null,
    className: null,
    id: null,
    to: null,
    img: null,
    title: null,
    subtitle: null,
    isFree: null,
    isHome: null,
    isMotion: null
  },
  data() {
    return {};
  },
  methods: {
    activeSubscription() {
      return this.$store.getters.activeSubscription;
    }
  }
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.grid-cards {
  z-index: 99999;
  
  .v-card {
    background: none !important;
    transition: all 0.2s ease;
    
    &:hover {
      .card-img {
        transform: scale(1.05);
      }
    }
    
    .v-image {
      // height: 260px !important;
      border-radius: 3px;
    }
    
    .v-responsive {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    
    .card-img {
      padding-bottom: 153.846% !important;
      //
      position: relative;
      transition: all 0.2s ease;
      background-color: #F0F0F0;
    }
    
    .v-image__image--cover {
      background-color: #F0F0F0;
    }
    
    .v-image__image,
    .v-image__placeholder {
      bottom: -1px;
      height: auto;
    }
    
    .motion {
      overflow: hidden;
      
      &:after {
        content: '';
        left: 5px;
        bottom: 5px;
        height: 37px;
        width: 37px;
        
        @media only screen and (max-width: 720px) {
          height: 20px;
          width: 20px;
        }
        
        position: absolute;
        background: url('../assets/img/motion_icon.svg') no-repeat center;
        
        background-size: contain;
        z-index: 2;
      }
    }
    
    .blocked {
      overflow: hidden;
      
      &:after {
        content: '';
        right: -1px;
        bottom: -1px;
        height: 53px;
        width: 53px;
        
        @media only screen and (max-width: 720px) {
          height: 37px;
          width: 37px;
        }
        
        position: absolute;
        background: url('../assets/img/block.svg') no-repeat center;
        
        background-size: contain;
        z-index: 2;
      }
    }
    
    &__title {
      .subheading {
        width: 100%;
        font-weight: 500;
        line-height: 20px;
      }
      
      span {
        font-size: 11px;
      }
    }
  }
}
</style>
